import React from 'react';
import { createPortal } from 'react-dom';

// "One more step" after a clock-in or job switch made in this app (Ryan, Oct 31 2026). The app starts
// the shift in QuickBooks Time with the office's connection, so QuickBooks Time treats it as a manager
// clock-in and holds the worker's location back until they tap Confirm in the QuickBooks Time app.
// Nobody can confirm for them — it is their OK to share their location — so the app reminds them.
// `kind` = 'in' | 'switch'.
export default function QbConfirmReminder({ kind = 'in', onClose }) {
  return createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 7000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: 12 }}>
      <div onClick={e => e.stopPropagation()} role="dialog" aria-label="Confirm in QuickBooks Time"
        style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 16, padding: '18px 18px 14px', boxShadow: '0 12px 40px rgba(0,0,0,0.3)', marginBottom: 'env(safe-area-inset-bottom)' }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#1e3a5f', marginBottom: 6 }}>📍 One more step</div>
        <div style={{ fontSize: 15, color: '#111', lineHeight: 1.5 }}>
          {kind === 'switch' ? 'Your new job went to QuickBooks Time.' : 'Your clock-in went to QuickBooks Time.'} Open the <b>QuickBooks Time</b> app and tap <b>Confirm</b> on the “Confirm Clock-In” message.
        </div>
        <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.5, marginTop: 8 }}>
          Until you do, your location isn’t shared with the office.
        </div>
        <div style={{ fontSize: 14, color: '#b91c1c', fontWeight: 700, lineHeight: 1.5, marginTop: 8 }}>
          Don’t tap Reject — that deletes your timesheet.
        </div>
        <button onClick={onClose} style={{ marginTop: 14, width: '100%', padding: '13px 0', borderRadius: 12, border: 'none', background: '#1e3a5f', color: '#fff', fontSize: 16, fontWeight: 800, cursor: 'pointer' }}>
          Got it
        </button>
      </div>
    </div>,
    document.body,
  );
}
